module.exports = __webpack_public_path__ + "img/jp-03.4c4b1460.png";